






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Form, Select } from '@/pages/profile/blocks';

@Component({
  components: {
    Form,
    Select,
  },
})
export default class NokoFilter extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly competition!: object[];

  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly students!: object[];

  @Prop({ type: String, default: '' })
  readonly competitionIdProp!: string;

  @Prop({ type: String, default: '' })
  readonly studentIdProp!: string;

  competitionId: string = '';

  studentId: string = '';

  @Watch('competitionId')
  isCompetitionIdChange(val: string) {
    if (val !== this.competitionIdProp) this.$emit('competitionIdChange', val);
  }

  @Watch('studentId')
  isStudentIdChange(val: string) {
    if (val !== this.studentIdProp) this.$emit('studentIdChange', val);
  }

  mounted() {
    this.competitionId = this.competitionIdProp;
    this.studentId = this.studentIdProp;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/progress/components/filter/NokoFilter.vue